import apiClient from '../api/axios';

// Story 18 — triggers a real file download from the export endpoint's blob response.
// Deliberately bypasses apiClient's default JSON handling via responseType: 'blob'.
// Story 18b — scope selects week vs month export (month is the currently-viewed week's month,
// Detailed format only); the two endpoints differ only in path and date param name.
export async function downloadScheduleCsv(dateYMD, format, scope = 'week') {
  const isMonth = scope === 'month';
  const res = await apiClient.get(isMonth ? '/api/schedules/month/export' : '/api/schedules/week/export', {
    params: isMonth ? { monthStart: dateYMD, format } : { weekStart: dateYMD, format },
    responseType: 'blob',
  });

  const disposition = res.headers?.['content-disposition'] || '';
  // Prefer the RFC 5987 filename*=UTF-8''... form — Spring's ContentDisposition also emits a
  // legacy RFC 2047 encoded-word filename="=?UTF-8?Q?...?=" first for older clients, and a
  // naive regex would grab that mangled form instead.
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  const plainMatch = disposition.match(/filename="?([^";]+)"?/i);
  const filename = utf8Match
    ? decodeURIComponent(utf8Match[1])
    : plainMatch
      ? plainMatch[1]
      : `schedule_${dateYMD}.csv`;

  const url = window.URL.createObjectURL(res.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
